import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';

@Component({
	selector: 'bt-date-filter-list',
	standalone: true,
	imports: [MatDialogModule, MatIconModule, FormsModule, MatButtonModule, MatInputModule, CommonModule, MatNativeDateModule, MatDatepickerModule],
	templateUrl: './date-filter-list.component.html',
	styleUrl: './date-filter-list.component.scss'
})
export class DateFilterListComponent implements OnInit {
	readonly #dialogRef = inject(MatDialogRef<DateFilterListComponent>);
	readonly data = inject(MAT_DIALOG_DATA);

	startDate: Date | null = null;
	endDate: Date | null = null;

	get dates(): { startDate: Date | null; endDate: Date | null } {
		return { startDate: this.startDate, endDate: this.endDate };
	}

	ngOnInit(): void {
		const toDate = (value: string | Date | null): Date | null => {
			if (!value) return null;
			if (value instanceof Date) return new Date(value.getTime());
			const [d, m, y] = value.split('/');
			return new Date(+y, +m - 1, +d);
		};

		this.startDate = this.data.startDate ? toDate(this.data.startDate) : null;
		this.endDate = this.data.endDate ? toDate(this.data.endDate) : null;
	}

	onClose(): void {
		this.#dialogRef.close();
	}
}
